<script>
import LoadingView from "@/components/visionTrainTrack/LoadingView.vue";
import moment from "moment";
// import { MapGender } from "@/common/util";
import cloneDeep from "lodash/cloneDeep";
// import sortBy from "lodash/sortBy";
const mapPlayback = {
  RECORDING: "记录中",
  RECORDED: "记录完成",
  REBUILD: "完整",
  PART_LOSE_ERROR: "片段丢失",
  TITLE_LOSE_ERROR: "元数据丢失",
  ORIGIN_PART_LOSE: "元数据丢失",
  FIRST_PART_LOSE: "首片段丢失",
  MID_PART_LOSE: "回放不连续",
  LAST_PART_LOSE: "尾片段丢失",
  NO_PART: "无回放片段",
  TEST_PART: "测试游戏回放"
};
export default {
  components: {
    LoadingView
  },
  props: {
    type: {}
  },
  data() {
    const stationId = this.$route.params.stationId;
    const patientId = this.$route.params.patientId;
    const trainingId = this.$route.params.trainingId;
    const gameId = this.$route.params.gameId;
    const patientAge = this.$route.params.patientAge || 5;
    return {
      trainingInfo: {},
      stationId,
      patientId,
      trainingId,
      tableData: [],
      tableTitle: [],
      finished: false,
      isShowMask: false,
      postMask: "",
      hidePhoto: true,
      totalScore: 0,
      trainingAt: "",
      trainingImageSrc: "",
      patientAge,
      gameId,
      avgData: [],
      playbackType: undefined
    };
  },
  created() {
    this.loadData();
  },
  beforeDestroy() {
    window.removeEventListener("message", this.postToken);
  },
  methods: {
    async loadData() {
      let data = await this.$http.getPatientFinishedTrainDetail(
        this.patientId,
        this.trainingId
      );
      let avgData = await this.$http.getPatientGameAvgStatistic(this.gameId, {
        age: this.patientAge
      });
      this.avgData = avgData;
      this.trainingInfo = data;
      if (data && data.result) {
        let titleArr = [];
        let table = JSON.parse(data.result);
        if (table.length > 0) {
          this.tableData = table.slice(1);
          let title = JSON.parse(table[0].content);
          for (let key in title) {
            if (key && key !== "levelState") {
              titleArr.push([key, title[key]]);
            }
          }
          this.tableTitle = titleArr;
          let totalScore = 0;
          let scoreList =
            this.tableData &&
            this.tableData.map(o => (totalScore = totalScore + o.score));
          this.totalScore = totalScore;
        }
        this.trainingAt = moment(data.trainingAt).format("YYYY-MM-DD HH:mm:ss");
        this.trainingImageSrc = `${this.$trainUrl}/gamecover/${data.playbackThumb}`;
        this.playbackType = mapPlayback[data.playbackState] || "--";
      }
    },
    postToken(e) {
      let tokenMessage = localStorage.getItem("token");
      if (this.isJsonString(e.data)) {
        let data = e.data;
        data = JSON.parse(data);
        this.eData = data;
        if (data.type === "getPixelInfo") {
          let messData = JSON.parse(localStorage.getItem("data"));
          let jsonData = JSON.stringify({
            type: "getPixelInfo",
            data: messData
          });
          window.frames[0].postMessage(jsonData, "*");
          this.finished = true;
        } else if (data.type == "postMask") {
          this.isShowMask = true;
          this.postMask = data.data;
        }
      } else if (e.data === "loadFinished") {
        this.isShowMask = false;
        this.finished = true;
      } else if (e.data === "quit") {
        let url = this.$route.fullPath;
        let urlAry = url.split("/");
        urlAry.pop();
        urlAry.pop();
        url = urlAry.join("/");
        this.$router.push({ path: `${url}` });
      } else if (e.data === "authenticationFailed") {
        this.$router.replace("/login");
      } else if (e.data == "requestToken") {
        window.frames[0].postMessage(`token:${tokenMessage}`, "*");
      } else if (e.data == "") {
      }
    },
    isJsonString(str) {
      try {
        if (typeof JSON.parse(str) == "object") {
          return true;
        }
      } catch (e) {}
      return false;
    },
    gameStart() {
      this.hidePhoto = false;
      const fram = document.getElementsByClassName("playRadioIframe")[0];
      fram.style.display = null;
      fram.src = `${this.$resourceUrl}/${this.trainingInfo.playbackUrl}/index.html?playbackId=${this.trainingInfo.playbackId}&hideBackBtn=true`;
      window.addEventListener("message", this.postToken, false);
    },
    tableValueFormatter(row, item) {
      console.log("hasakai++++++++++++++");
      const levelAvgData = this.avgData.filter(o => o.level === row.levelNum);
      const avgData =
        levelAvgData.length > 0 ? levelAvgData[0].data : undefined;
      if (item[0] === "levelNum") {
        return `${row[item[0]]}`;
      } else if (avgData) {
        const avgValue = avgData[item[1]];
        if (avgValue && avgValue.sumVal) {
          const calcAvg =
            avgValue.count > 0
              ? (avgValue.sumVal / avgValue.count).toFixed(2)
              : avgValue.sumVal;
          return `${row[item[0]]}（${calcAvg}）`;
        } else {
          return `${row[item[0]]}（--）`;
        }
      } else {
        return `${row[item[0]]}（--）`;
      }
    }
  }
};
</script>
<template>
  <div class="trainLevelDetailPage">
    <el-breadcrumb class="headerLinkView" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>您的位置：</el-breadcrumb-item>
      <el-breadcrumb-item :replace="true" :to="{ path: '/index/patientManagement' }">患者管理</el-breadcrumb-item>
      <el-breadcrumb-item
        :replace="true"
        :to="{ path: `${this.$route.path.replace(`/finishedTrainDetail/${trainingId}/${gameId}/${patientAge}`, '')}` }"
      >患者详情</el-breadcrumb-item>
      <el-breadcrumb-item>训练详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card cardStyle" shadow="never">
      <div class="trainLevelDetail">
        <el-row :gutter="24">
          <el-col :span="12">
            <div class="item">
              <span class="detailTitleText">序号：</span>
              <span class="detailText">{{trainingInfo.courseNumber}}</span>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="item">
              <span class="detailTitleText">训练时间：</span>
              <span class="detailText">{{trainingAt}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <div class="item">
              <span class="detailTitleText">训练类别：</span>
              <span class="detailText">{{trainingInfo.gameLabel}}</span>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="item">
              <span class="detailTitleText">训练关卡：</span>
              <span class="detailText">{{trainingInfo.initialLevel}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <div class="item">
              <span class="detailTitleText">训练游戏：</span>
              <span class="detailText">{{trainingInfo.gameName}}</span>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="item">
              <span class="detailTitleText">总得分：</span>
              <span class="detailText">{{totalScore}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <div class="item">
              <span class="detailTitleText">刺激模式：</span>
              <span
                class="detailText"
              >{{trainingInfo.modeList && trainingInfo.modeList.length > 0 ? `${trainingInfo.modeList[0].name}等` : ""}}</span>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="item">
              <span class="detailTitleText">评估值：</span>
              <span class="detailText">
                {{trainingInfo.quality || '--'}}
                <!-- <gameRateStar :score="trainingInfo.score" /> -->
              </span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <div class="item">
              <span class="detailTitleText">回放状态：</span>
              <span class="detailText">{{playbackType}}</span>
            </div>
          </el-col>

          <!-- <el-col :span="12">
            <div class="item">
              <span class="detailTitleText">总得分：</span>
              <span class="detailText">{{totalScore}}</span>
            </div>
          </el-col>-->
        </el-row>
      </div>
    </el-card>
    <div class="replayHeaderText">视频回放</div>
    <el-row>
      <div class="playRadioView" @click="gameStart">
        <iframe class="playRadioIframe" :style="{'display': 'none'}" frameborder="no" src></iframe>
        <img v-if="hidePhoto" class="playRadioIframe" @click="gameStart" :src="trainingImageSrc" />
        <div class="replayImgMode" v-if="hidePhoto"></div>
        <img class="replayIcon" v-if="hidePhoto" @click="gameStart" src="../../assets/视频回放.svg" />
        <LoadingView
          v-if="!hidePhoto"
          :finished="finished"
          :hideReturn="true"
          :style="{'position': 'absolute',width: '84%',left: 'auto'}"
        />
      </div>
    </el-row>
    <el-row>
      <div class="trainLevelDetailTable">
        <el-table
          :data="tableData"
          :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
          :cell-style="{'padding-left': '5px'}"
        >
          <el-table-column
            v-for="item in tableTitle"
            :key="item[0]+ item[1]"
            min-width="100"
            :property="item[0]"
            :label="item[1]"
            :formatter="(row) => tableValueFormatter(row, item)"
          ></el-table-column>
          <el-table-column min-width="100" property="levelState" label="闯关结果">
            <template slot-scope="scope">
              <div v-if="scope.row.levelState === 'success'">
                <span class="winSuccess">
                  成功
                  <i class="el-icon-success"></i>
                </span>
              </div>
              <div v-else-if="scope.row.levelState === 'fail'">
                <span class="winFailed">
                  失败
                  <i class="el-icon-error"></i>
                </span>
              </div>
              <div v-else>
                <span>未完成</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.trainLevelDetailPage {
  .trainLevelDetail {
    .item {
      line-height: 33px;
    }
    .detailText {
      color: rgba(0, 0, 0, 0.65);
    }
    .detailTitleText {
      display: inline-block;
      width: 80px;
    }
  }
  .replayHeaderText {
    margin-left: 3%;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 24px;
    margin-bottom: 10px;
  }
  .el-row {
    display: flex;

    &:last-child {
      margin-bottom: 0;
    }
  }
  .cardStyle {
    margin: 0 1%;
    border: 0px;
  }
  .el-col {
    align-self: center;
    border-radius: 4px;
  }
  .playRadioView {
    height: 500px;
    width: 94%;
    margin: auto;
    cursor: pointer;
    // background-color: aquamarine;
    .playRadioIframe {
      width: 100%;
      height: 100%;
    }
    .replayIcon {
      position: relative;
      float: left;
      left: 48%;
      bottom: 55%;
      width: 35px;
      height: 35px;
    }
    .replayImgMode {
      position: absolute;
      top: 0;
      left: 2%;
      width: 96%;
      height: 100%;
      opacity: 0.6;
      background-color: #000000 !important;
    }
  }
  .trainLevelDetailTable {
    width: 84%;
    margin: auto;
    .winSuccess {
      > i {
        color: #67c23a;
        padding-left: 5px;
      }
    }
    .winFailed {
      color: red;
      > i {
        padding-left: 5px;
      }
    }
  }
  .headerLinkView {
    padding-top: 10px;
    padding-left: 10px;
    .el-breadcrumb__inner.is-link,
    .el-breadcrumb__inner a {
      color: #00c1de;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/patientManagement/finishedTrainDetail.vue